/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */





// function getHeights(e){
//         var get_height = e.clientHeight;
//         console.log('hi',get_height);
        
//         e.querySelectorAll('.product-item').forEach(function(d){
//             console.log('hi2');
//             d.setAttribute('style', 'height:'+ get_height+'px');
//         })
// };

// document.querySelectorAll('.product-list').forEach(getHeights);

var specifications_content = document.getElementById('product_specifications');
var model_content = null;
var short_content = null;
var features_content = null;
var specifications_content_2 = null;

if(typeof(document.getElementById('product_model')) != 'undefined' && document.getElementById('product_model') != null){
	model_content = document.getElementById('product_model').innerHTML;
}
if(typeof(document.getElementById('short_content')) != 'undefined' && document.getElementById('short_content') != null){
	short_content = document.getElementById('short_content').innerHTML;
}
if(typeof(document.getElementById('product_features')) != 'undefined' && document.getElementById('product_features') != null){
	features_content = document.getElementById('product_features').innerHTML;
}
if(typeof(document.getElementById('product_specifications')) != 'undefined' && document.getElementById('product_specifications') != null){
	specifications_content_2 = document.getElementById('product_specifications').innerHTML;
}


/*if (specifications_content != null && specifications_content != '') {
	var fragment = document.createDocumentFragment();
	fragment.appendChild(specifications_content);
	document.getElementById('extra-content').appendChild(fragment);
}*/

if (specifications_content_2 != null && specifications_content_2 != '') {
	let contentToAdd = getContentToAdd('Specifications', 'specifications_content_r', specifications_content_2);
	document.getElementById('extraContentHolder').innerHTML += contentToAdd;
}

if (model_content != null && model_content != '') {
	let contentToAdd = getContentToAdd('Model', 'model_content_r', model_content);
	document.getElementById('extraContentHolder').innerHTML += contentToAdd;
}

if (short_content != null && short_content != '') {
	let contentToAdd = getContentToAdd('Short Description', 'short_content_r', short_content);
	document.getElementById('extraContentHolder').innerHTML += contentToAdd;
}

if (features_content != null && features_content != '') {
	let contentToAdd = getContentToAdd('Features', 'features_content_r', features_content);
	document.getElementById('extraContentHolder').innerHTML += contentToAdd;
}

function getContentToAdd(title, contentType, contentToAdd){
	console.log(contentToAdd);
	let random = randstr();
	let content = '<div class="card"><button class="card__collapsible-button" data-action="toggle-collapsible" aria-expanded="false" aria-controls="block-template--'+random+'"><span class="card__title heading text--600 h6">'+title+'</span><span class="plus-button plus-button--large"></span></button><div id="block-template--'+random+'" class="card__collapsible" style="height: 0px;"><div class="card__collapsible-content" id="extra-content"><div class="rte text--pull"><div class="'+contentType+'"></div></div><div id="'+contentType+'">'+contentToAdd+'</div></div></div></div>';
	return content;
}

function randstr(prefix = 'hammer')
{
	return Math.random().toString(36).replace('0.',prefix || '');
}


//add height to image on homepage on resize
window.addEventListener('resize', function(event) {
	var homeImg = document.getElementsByClassName("slideshow__image")[0].clientHeight;
	var homeSlider = document.getElementsByClassName("flickity-viewport")[0];
	homeSlider.style.height = homeImg + "px";
	
});

